






























































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaservizio } from '@/data/models/tipologiaservizio.model';
import { Search, SortDirection } from '@/data/models/search.model';

@Component
export default class TipologiaservizioList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: () => [] }) selected!: Tipologiaservizio[];
	
	@Inject('CrudService') crudService!: CrudService<Tipologiaservizio>;

	rows: Tipologiaservizio[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('tipologiaservizio');
	checkedRows: Tipologiaservizio[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadTipologieservizio() {

		const datareq = this.crudService.searchEntities(
			Tipologiaservizio,
			'tipologiaservizio',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Tipologiaservizio,
			'tipologiaservizio',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editTipologiaservizio(item: Tipologiaservizio) {
		this.$emit('edit', item);
	}

	openTipologiaservizio(item: Tipologiaservizio) {
		this.$emit('open', item);
	}

	deleteTipologiaservizio(item: Tipologiaservizio) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadTipologieservizio();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadTipologieservizio();
	}

}
